import styled from 'styled-components'

export const Wrapper = styled.div``

export const Description = styled.div`
  color: #363636;
  font-size: 16px;
`

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
  .rankmiTable-container > .ant-col {
    justify-content: flex-end;
  }
  .rankmiTable-pagination {
    margin-top: 6px;
  }
`

export const CourseName = styled.div`
  max-width: 339px;
  display: flex;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
